import React from "react";
import styles from "./Chevron.module.css";

interface Props {
	up?: boolean;
	white?: boolean;
}

export function Chevron(props: Props) {
	const { up, white } = props;

	let classes = styles.chevronDown;
	if (up) {
		classes = `${classes} ${styles.chevronUp}`;
	}
	if (white) {
		classes = `${classes} ${styles.chevronWhite}`;
	}

	return (
		<span id="chev" className={classes}>
			<svg
				height="100%"
				preserveAspectRatio="xMidYMid"
				version="1.1"
				viewBox="0 0 100 100"
				width="100%"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g className={styles.chevronContainer}>
					<line className={styles.chevronLine1} x1="10" y1="50" x2="50" y2="50" />
					<line className={styles.chevronLine2} x1="90" y1="50" x2="50" y2="50" />
				</g>
			</svg>
		</span>
	);
}
